/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

import { Dialog, Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';

import { InboundInvoicePrepopulatedData } from 'services/apis/SwipeRxWmsApiInboundInvoice/type';

import S from './CreateInboundInvoiceDialog.styles';

interface ICreateInboundInvoiceProps {
  onClose: () => void;
  openModal: boolean;
  inboundInvoiceData: InboundInvoicePrepopulatedData;
  setInboundInvoiceData: (data: InboundInvoicePrepopulatedData) => void;
  progressToReceivingProcess: (isNewInvoice?: boolean) => void;
}

export const CreateInboundInvoiceDialog: React.FC<
  ICreateInboundInvoiceProps
> = ({
  onClose,
  openModal,
  inboundInvoiceData,
  setInboundInvoiceData,
  progressToReceivingProcess,
}) => {
  const [dateString, setDateString] = React.useState(
    inboundInvoiceData.invoice_date,
  );
  const [error, setError] = React.useState(false);

  useEffect((): void => {
    if (dateString === 'Invalid DateTime' || !dateString) {
      setError(true);
    } else {
      setInboundInvoiceData({
        ...inboundInvoiceData,
        invoice_date: dateString,
      });
      setError(false);
    }
  }, [dateString]);

  const onFieldChange = (
    _type: keyof InboundInvoicePrepopulatedData,
    value: string,
  ): void => {
    let newInboundInvoice = structuredClone(inboundInvoiceData);
    const newValue = typeof value === 'string' ? value.trim() : value;
    if (_type === 'invoice_date') {
      setDateString(value || '');
    } else {
      newInboundInvoice = { ...newInboundInvoice, [_type]: newValue };
      setInboundInvoiceData(newInboundInvoice);
    }
  };

  return (
    <Dialog
      onClose={onClose}
      open={openModal}
      style={{ whiteSpace: 'pre-line' }}
    >
      <S.TitleWrapper>
        <S.Title data-testid="modalCreateInboundInvoiceHeader">
          Create Inbound Invoice
        </S.Title>
      </S.TitleWrapper>
      <Grid container style={{ marginTop: '12px', width: '450px' }}>
        <S.FieldRowWrapper container item xs={12}>
          <Grid item xs={4}>
            <S.Text>Invoice Number</S.Text>
          </Grid>
          <S.InputWrapper>
            <TextField
              data-testid="inputCreateInboundInvoiceText"
              placeholder="Inbound Invoice Number"
              variant="outlined"
              value={inboundInvoiceData.invoice_number || ''}
              onChange={(event): void =>
                onFieldChange('invoice_number', event.target.value)
              }
              fullWidth
            />
          </S.InputWrapper>
        </S.FieldRowWrapper>
        <S.FieldRowWrapper container item xs={12}>
          <Grid item xs={4}>
            <S.Text>Invoice Date</S.Text>
          </Grid>
          <S.InputWrapper>
            <DatePicker
              format="dd/MM/yyyy"
              value={dateString ? DateTime.fromISO(dateString) : null}
              onChange={(value) => {
                onFieldChange('invoice_date', value?.toString() || '');
              }}
              slotProps={{
                textField: {
                  id: 'field-invoice-date-inbound-modal',
                  variant: 'outlined',
                  fullWidth: true,
                },
              }}
            />
          </S.InputWrapper>
        </S.FieldRowWrapper>
      </Grid>
      <S.FooterWrapper>
        <S.CancelButton
          data-testid="buttonCreateInboundInvoiceNoModal"
          onClick={onClose}
        >
          Cancel
        </S.CancelButton>
        <S.OKButton
          data-testid="buttonCreateInboundInvoiceYesModal"
          disabled={
            !inboundInvoiceData.invoice_date ||
            !inboundInvoiceData.invoice_number ||
            error
          }
          onClick={() => {
            progressToReceivingProcess(true);
            onClose();
          }}
        >
          Submit
        </S.OKButton>
      </S.FooterWrapper>
    </Dialog>
  );
};
